import { render, staticRenderFns } from "./PhasesView.vue?vue&type=template&id=c8e934fa&scoped=true"
import script from "./PhasesView.vue?vue&type=script&lang=ts"
export * from "./PhasesView.vue?vue&type=script&lang=ts"
import style0 from "./PhasesView.vue?vue&type=style&index=0&id=c8e934fa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8e934fa",
  null
  
)

export default component.exports